import React from "react";
import './VisitModal.css';
export default function VisitModal({ onClose, message, title, buttons = [] }) {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>×</button>
        <h2 className="modal-title">{title}</h2>
        <p className="modal-message">{message || "Create an account to save your fave recs 💛"}</p>
        <div className="modal-actions">
          {buttons.map((btn, idx) => (
            <button
              key={idx}
              className={btn.className || "link-button"}
              onClick={btn.onClick}
            >
              {btn.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
